

import { HomeComponentMainDiv } from "../../styles/homeComp/homeComponentsStyle";
import Footer from "../reusable/footer";
import AppHeader from "../reusable/header";
import HomeHeroComponent from "./homeHero";



const HomeComponent = () => {

  return (
    <HomeComponentMainDiv>
      <AppHeader
        hideContact={false}
        logo={"/images/sixthWhiteIcon.png"}
        top="2rem"
        width="8rem"
        mobileWidth="8rem" />

      <div className="video-container">
        <div className="video-holder">
          <video autoPlay loop muted>
            <source src="./images/herovideo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

        </div>


      </div>
      <div className="content">
        <HomeHeroComponent />
        <Footer />
      </div>
    </HomeComponentMainDiv>
  );
};

export default HomeComponent;
